const DataLoading = () => {
  return (
    <div className="wrap_loading">
      <span className="loader type_small"></span>
      <span className="screen_out">데이터 로딩중입니다.</span>
    </div>
  );
};

export default DataLoading;
